import { Spacer } from "../../../../common/components/Spacer";
import { useGetContractPeriodCurtailmentObjectsQuery } from "../../../../requests_cm/gecoContractsService/service";
import { useRtkQueryDynamicEndpoint } from "../../../../common/hooks/useRtkQueryDynamicEndpoint";
import CircularProgress from "@mui/material/CircularProgress";
import CurtailmentObjectBySite from "./CurtailmentObjectBySite";
import NoDataMessage from "../../../../common/components/NoDataMessage";
import { useCurtailementObjectsFilters } from "../../../../common/hooks/useCurtailementObjectsFilters";
import { Box } from "@mui/material";
import { FluidButton } from "../../../../common/components/FluidButton";
import { useState } from "react";
import { BuildCurtailmentObjectsModalContainer } from "./BuildCurtailmentObjectsModal/BuildCurtailmentObjectsModalContainer";

const CurtailmentObjectTab = ({
	contractPeriodId,
	country,
}: {
	contractPeriodId: number;
	country:string
}) => {
	const { data, isLoading, refetch } = useRtkQueryDynamicEndpoint(
		useGetContractPeriodCurtailmentObjectsQuery
	)({ contract_period_id: contractPeriodId });

	const { curtailementObjectsGroupsBySites } =
		useCurtailementObjectsFilters(data);

		const [isBuildCurtailmentOpen, setOpenBuildCurtailment] = useState(false);
	
		const handleClose = () => {
			setOpenBuildCurtailment(false);
			refetch();
		};

	return (
		<>
			<Spacer gap={24} />
			{isLoading && <CircularProgress />}
			{!isLoading && (
				<>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							paddingRight: "24px",
							marginBottom: "32px",
						}}
					>
						{country === "DE" && <Box sx={{ display: "flex", gap: "16px" }}>
							<FluidButton
								label="Build Curtailment objects"
								onClick={() => setOpenBuildCurtailment(true)}
								icon="add_circle_outline"
							/>
							</Box>
							}
						
						</Box>
					{data && !data.length && <NoDataMessage />}
					{!!data?.length &&
						curtailementObjectsGroupsBySites.map(
							(curtailmentObjectGroup) => (
								<CurtailmentObjectBySite
									key={curtailmentObjectGroup?.site?.name}
									curtailmentObjectGroup={
										curtailmentObjectGroup
									}
								/>
							)
						)}
				</>
			)}
			<BuildCurtailmentObjectsModalContainer
							contractperiodId={contractPeriodId}
							isOpen={isBuildCurtailmentOpen}
							country={country}
							onClose={handleClose}
						/>
		</>
	);
};

export default CurtailmentObjectTab;
